import { ActionTypes, SetSelectedTab } from './types';

export const setSelectedTab = (tab: number): SetSelectedTab => ({
  type: ActionTypes.SET_SELECTED_TAB,
  tab,
});
